import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import VueSimpleAlert from "vue-simple-alert";

import App from './App.vue';
import routes from './routes';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueSimpleAlert);
Vue.use(Vuex);
const router = new VueRouter({mode: 'history', routes});


const store = new Vuex.Store(
{
	state: 
	{
		userlogged: "0"
	},
	mutations: 
	{
		saveUserLogged(state, loggedUser) 
		{
			state.userlogged = loggedUser;
		}
	},
	actions: {
		saveUserLogged(context, loggedUser) 
		{
			context.commit("saveUserLogged", loggedUser);
		}
	},
	getters: 
	{
		userId: state => 
		{
			return state.userlogged;
		}
	},
	plugins: [createPersistedState()]
});


new Vue(
{
	store: store,
	router,
	render: h => h(App)
}).$mount('#page');
